export default __webpack_public_path__ + "static/im-b2b016a2d5301ae17a43c24192af8f63.svg";